import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import RecordTablePartnersProducts from 'views/products/partners-products/recordTablePartnersProducts'; // Importing a specific view for displaying partner products
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing the landing report view.
 * @extends JetView
 */
export default class recordLandingReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view layout.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translating labels
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetching from configuration
                },
            ],
        };

        // Left column configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left column
                    css: theme, // Apply the current theme
                    elements: [
                        { view: 'label', label: _('Historial'), width: 150 }, // Label with localized text
                    ],
                },
                RecordTablePartnersProducts, // Including the RecordTablePartnersProducts view
                toolbar, // Adding the previously defined toolbar
            ],
        };

        // Return the main layout configuration
        return {
            width: screen !== 'small' ? 500 : 230, // Conditional width based on screen size
            height: screen !== 'small' ? 300 : 230, // Conditional height based on screen size
            type: 'wide', // Layout type
            cols: [left], // Columns configuration
        };
    }
}

// FILE DOCUMENTED
